<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('categoriemarchand.categorie_management')}}
                    <v-spacer></v-spacer>
                    <v-text-field solo
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="category_marchands"
                        :search="search"
                        :loading="category_marchands===undefined" loading-text="Chargement en cours..."
                        sort-by="label"
                        class="elevation-1">
                    <template v-slot:item._file="{item}">
                        <a :href="item._file">{{getFileOriginalName(item._file)}}</a>
                    </template>
                    <template v-slot:item._created_at="{item}">
                        {{ new Date(item._created_at).toLocaleDateString()}}
                    </template>
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                    <v-btn color="default" dark class="mb-2" v-on="on">{{$t('add')}}</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                                        <v-alert v-if="errors.operation" dense outlined type="error">
                                            {{errors.operation}}
                                        </v-alert>
                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field solo :rules="codeRules" v-model="editedItem._code" :label="$t('code')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                    <v-text-field solo :rules="labelRules" required v-model="editedItem._name" :label="$t('name')" ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" >
                                                    <v-textarea solo
                                                            :rules="descriptionRules"
                                                            v-model="editedItem._description"
                                                            name="input-7-4"
                                                            :label="$t('description')"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click.prevent="close">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary" :disabled="!valid || mis"  @click.prevent="save">{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                       <!-- <template>
                            <div class="text-center">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                color="primary"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            Dropdown
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item  @click="editItem(item)">
                                            <v-list-item-icon>
                                                <v-icon color="#29B3A6"> mdi-pencil
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>

                                                <v-list-item-title >
                                                    Modifier
                                                </v-list-item-title>
                                            </v-list-item-content>

                                        </v-list-item>
                                        <v-list-item  @click="description(item)">
                                            <v-list-item-icon>
                                                <v-icon color="#29B3A6">  mdi-eye
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>

                                                <v-list-item-title>
                                                    Description
                                                </v-list-item-title>
                                            </v-list-item-content>

                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </template>-->

                        <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black&#45;&#45;text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item  @click="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6"> mdi-pencil
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title >
                                                Modifier
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item  @click="description(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">  mdi-eye
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title>
                                                Description
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>

            <customsnackbar :snackbar="customSnack.snackbar"
                            :text="customSnack.text"
                            :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
                            :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
        </div>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../mixins/helpers";

    export default {
        name: "CategoryMarchands",
        mixins:[helpers(this)],
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                errors:{},
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                search: '',
                desc:"",
                dialog3: false,
                dialog: '',
                id:undefined,
                headers: [
                    {text: this.$t('code'), value: '_code'},
                    {text: this.$t('name'), value: '_name'},
                    {text: this.$t('date'), value: '_created_at'},
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _description: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _description: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                labelRules: [
                    v => !!v || this.$t('name_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || this.$t('code_required'),
                ],
                descriptionRules: [
                    v => !!v || this.$t('description_required'),
                ],
                fileRules: [
                    v => !!v || this.$t('file_required'),
                ],
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('categoriemarchand.new_categorie') : this.$t('categoriemarchand.update_categorie')
            },
            ...mapState('category_marchands/',['category_marchands'])
        },
        mounted(){
            this.$store.dispatch('category_marchands/getCategorie_Marchand').then(response=>{
                window.console.log('category_marchands',response)
            });
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            showdescription(vdes){
                this.desc = vdes;
                this.dialog3 = true;
            },
            editItem (item) {
                this.editedIndex = this.category_marchands.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },

            description (item) {
                Swal.fire({
                    title: this.$t('description'),
                    timerProgressBar: false,
                    text: item._description,
                    confirmButtonText: "OK",
                    confirmButtonColor:'#29B3A6',
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },

            save () {
                this.customSnack.snackbar = false;
                this.mis=true;

                let VueBox = this;
                let data = new FormData();
                data.append("code",this.editedItem._code);
                data.append("description",this.editedItem._description);
                data.append("name",this.editedItem._name);
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('category_marchands/setCategorie_Marchand',data).then((response)=>{
                    console.log('set categorie response',response)
                    this.submitting = false;
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{
                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        VueBox.toast('success',this.$t(response.message));

                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

</style>
